import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { DocumentClient } from "../../repsaApi";

const client = new DocumentClient(app_uri, axiosClient());

export default client;
